module.exports = __webpack_public_path__ + "img/icon-solicitudes-libros.2a4a23f2.svg";